export const getDefaultTimezoneValue = () => {
  let hours;
  let minutes;
  const timezoneOffset = new Date().getTimezoneOffset() / -60;

  let wholeNumber
  if (timezoneOffset.toString().split('.')[1] == undefined) {
    wholeNumber = timezoneOffset.toString();
  } else {
    wholeNumber = timezoneOffset.toString().split('.')[0];
  }

  if (wholeNumber <= 0 && wholeNumber >= -10) {
    wholeNumber *= -1;
    hours = "-0" + wholeNumber;
  } else if (wholeNumber <= 0 && wholeNumber < -10) {
    hours = wholeNumber;
  } else if (wholeNumber > 0 && wholeNumber < 10) {
    hours = "+0" + wholeNumber;
  } else {
    hours = "+" + wholeNumber;
  }

  let decimals = timezoneOffset - Math.floor(timezoneOffset);
  if (timezoneOffset.toString().split('.')[1] == undefined) {
    decimals = 0;
  } else {
    const decimalPlaces = timezoneOffset.toString().split('.')[1]?.length;
    decimals = decimals.toFixed(decimalPlaces);
  }

  if (decimals == 0) {
    minutes = ":00"
  } else if (decimals == 0.5) {
    minutes = ":30"
  } else if (decimals == 0.75) {
    minutes = ":45"
  }

  return (hours + minutes);
};

/**
 * Return a formatted date string for the datetime-local input min attribute.
 * Optionally pass a number of days in the future to set the minimum date.
 * @param {number} daysAfter 
 * @returns 
 */
export const getDeliveryDatepickerMin = (daysAfter = 0) => {

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + daysAfter);

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
  return formattedDate;

};

/**
 * Get the lead time for gift card shipments based on the fulfillment type and shipping country.
 * @param {string} fulfillmentType 
 * @param {string} country 
 * @param {*} shippingLeadTimes 
 * @returns 
 */
export const getShippingLeadTime = (
  fulfillmentType,
  country,
  shippingLeadTimes,
) => {

  // Digital fulfillments have no lead time
  if (fulfillmentType !== "physical") {
    return 0;
  }

  const defaultLeadTime = 14;

  if (!country || !shippingLeadTimes?.continents) {
    return defaultLeadTime;
  }

  // Search the continent shipping data for the country and return lead_time
  const countryLeadTime = Object.values(shippingLeadTimes.continents).reduce(
    (leadTime, continent) => {
      const countryInContinent = continent.countries.includes(country);
      return (countryInContinent && continent.lead_time) ? continent.lead_time : leadTime;
    },
    defaultLeadTime
  );

  return countryLeadTime;

};
